import { DescribeProperty } from '../../common';

export class SavedViewEntryResponse {
  @DescribeProperty({
    description: 'The ID of the saved view',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  id: string;

  @DescribeProperty({
    description: 'The ID of the project the saved view belongs to',
    example: '123e4567-e89b-12d3-a456-426614174000',
    type: 'string',
    format: 'uuid',
  })
  projectEntryId: string;

  @DescribeProperty({
    description: 'Display name of the saved view',
    example: 'Floor 2 — east wing',
    type: 'string',
  })
  name: string;

  @DescribeProperty({
    description: 'Base64-encoded PNG snapshot of the scene',
    type: 'string',
  })
  thumbnail: string | null;

  @DescribeProperty({
    description:
      'Serialized scene state (sections, measurements, ...). The BCF viewpoint is served separately via `bcfViewpointUrl`.',
    type: 'object',
  })
  state: Record<string, unknown>;

  @DescribeProperty({
    description:
      'Short-lived presigned S3 URL that returns the BCF viewpoint JSON. Returned only by `getOne` / create / update — `null` for list responses.',
    type: 'string',
  })
  bcfViewpointUrl: string | null;

  @DescribeProperty({
    description: 'Whether the saved view is visible to all project viewers',
    type: 'boolean',
    example: true,
  })
  isPublic: boolean;

  @DescribeProperty({
    description:
      'Whether the requesting user is the owner of this saved view. Public views with no owner have `isOwner: false`.',
    type: 'boolean',
    example: false,
  })
  isOwner: boolean;

  @DescribeProperty({ description: 'Updated at', type: 'string', format: 'date-time' })
  updatedAt: Date;

  @DescribeProperty({ description: 'Created at', type: 'string', format: 'date-time' })
  createdAt: Date;
}
